import { Injectable } from '@angular/core';
import {ContentDataByDataviewDTO, DataViewDto, FieldTableDto, Table} from "@tj/tj-dmp-lib-api";
import {FieldComponent} from "./field.component";
import {FieldTagComponent} from "../field-tag/field-tag.component";

@Injectable({
  providedIn: 'root'
})
export class FieldService {

    public mode: 'EDIT'|'READ' = 'READ';
    public data: ContentDataByDataviewDTO;
    public tables: Table[];
    public partner: string;
    public datastore: string;
    public dataView: DataViewDto;
    private fieldList: Array<FieldComponent> = [];
    private fieldTagList: Array<FieldTagComponent> = [];
    private reassignedCustomer: number = null;
    constructor() { }

    updateData(fiedTable: FieldTableDto, $event: any) {
    }

    clearField() {
        this.fieldList = [];
        this.fieldTagList = [];
    }
    addField(field: FieldComponent) {
        this.fieldList.push(field);
    }

    addTag(field: FieldTagComponent) {
        this.fieldTagList.push(field);
    }

   reassignCustomer(id: number):void {
        this.reassignedCustomer = id;
    }

    removeFieldByUuid(uuid: any) {
        if (this.fieldList) {
            this.fieldList = this.fieldList.filter(f => f.uuid !== uuid);
        }
    }

    getFields() {
        return this.fieldList;
    }

    getFieldTags() {
        return this.fieldTagList;
    }

    getReassignedCustomer(){
        return this.reassignedCustomer;
    }

    refreshAllFields() {
        this.fieldList.forEach(field => {
            field.loadData();
        })
    }
    
}
